module.exports = __webpack_public_path__ + "static/media/23a.c6a6f3b3.jpg";